<template>
  <div>
    <van-nav-bar title="邀请有奖" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div>
        <img src="@/assets/zhaomu.jpg" style="width:100%" />
    </div>
    <div class="field">
      <van-cell-group>
        <van-field v-model="name" label="真实姓名" placeholder="请输入姓名" />
        <van-field v-model="email" label="邮箱" placeholder="请输入邮箱（选填）" />
        <van-field v-model="mobile" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <van-button size="large" style="background-color:#FDDE14" v-on:click="clickSubmit()">提交信息</van-button>
    </div>
    
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "yaoqing",
  components: {
    TabBar
  },
  data() {
    return {
      user: { token: "", user: {} },
      name: "",
      mobile:'',
      email:''
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    clickSubmit() {
      this.$http
        .post(
          this.GLOBAL.API + "s_user/share/apply",
          { true_name: this.name,mobile:this.mobile,email:this.email },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          this.onLoad();
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  }
};
</script>
<style lang="scss" scoped>
.field{
    width:70%;
    margin:0 auto 0;
}
</style>